module.exports = __webpack_public_path__ + "static/media/mobile_screen.92cf8eae.png";